var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(_vm._s(_vm.$t('pagination', { currentPage: _vm.currentPage, maxPage: Math.max(_vm.currentPage, _vm.lastPage), total: _vm.total })))])
}
var staticRenderFns = []

export { render, staticRenderFns }